<nb-action class="close-dialog" icon="close-outline" (click)="closeAction()"></nb-action>
<nb-card>
  <nb-card-header>Ajouter un partage de donnée</nb-card-header>
  <nb-card-body>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label>Partager avec</label>
          <nb-select [(ngModel)]="chooseExtern" fullWidth>
            @for (extern of externs; track extern) {
              <nb-option [value]="extern.id">{{ extern.name
              }}</nb-option>
            }
          </nb-select>
        </div>
      </div>
    </div>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton fullWidth status="primary" shape="round" (click)="saveAction()" class="mb-2"
    [disabled]="!chooseExtern">Choisir</button>
  </nb-card-footer>
</nb-card>